import type { AvvirEvent } from "type_aliases";
import { OrganizationMember } from "../../models/domain/organization_member";

export type OrganizationMemberCreatedEvent = AvvirEvent<typeof ORGANIZATION_MEMBER_CREATED, {
  firebaseOrganizationId: string,
  member: OrganizationMember
}>

export const organizationMemberCreated = (firebaseOrganizationId: string, member: OrganizationMember): OrganizationMemberCreatedEvent => ({
  type: ORGANIZATION_MEMBER_CREATED,
  payload: {
    firebaseOrganizationId,
    member
  }
});

export const ORGANIZATION_MEMBER_CREATED = "organization_member_created";
